import { useTranslation } from 'react-i18next';
import MainTitle from '../../common/MainTitle';
import Icon from '../../common/Icon';
import ImageLink from '../../../js/utils/ImageLink';

export default function KeyTeamsSlider({ buttonLink, slides }) {
  const { t } = useTranslation(['CareersPage']);

  console.log('slides', slides);

  return (
    <div className="key-teams">
      <div className="key-teams__container container">
        <div className="key-teams__content">
          <header className="key-teams__header">
            <MainTitle type="dark" className="text--6xl">
              <span className="decorated-line decorated-line--dark decorated-line--right">
                {t('join')}
              </span>
              <span>{t('ourTeam')}</span>
            </MainTitle>
          </header>
          <p>
            At Al Manara School, we are more than just educators—we are mentors, innovators, and
            leaders working together to shape a brighter future for the next generation. If you’re
            passionate about making a difference and inspiring excellence, we’d love for you to join
            our team Join Al Manara School and contribute to shaping bright futures
          </p>
          <a target="_blank" className="button action-button" href={buttonLink}>
            <Icon name="open-light" />
            <span>{t('heroAction')}</span>
          </a>
        </div>

        <div className="key-teams__media">
          {slides.map((slide, index) => (
            <img src={ImageLink(slide.image?.url)} />
          ))}
        </div>
      </div>
    </div>
  );
}
